import { z } from 'zod';
import { configFloorSchema } from './IConfigFloor';
import { baseAreaSchema } from './IBaseArea';
import { AreaTypeEnum } from './AreaType.enum';

// Schemas (source of truth)
export const configAreaSchema = z.object({ ...configFloorSchema.shape, ...baseAreaSchema.shape }).extend({
	areaType: z.enum(AreaTypeEnum).optional(),
	areaSortIndex: z.number().optional(),
});

// Types (derived from schemas)
export type IConfigArea = z.infer<typeof configAreaSchema>;
